import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { SubjectService } from '../../../../services/subject/subject.service';
import { Subject } from '../../../../models/subjects/subject';

export class SubjectDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<Subject[]> = new BehaviorSubject<Subject[]>([]);

    get data(): Subject[] {
        return this.dataChange.value;
    }

    constructor(
        private subjectService: SubjectService,
    ) {
        setTimeout(() => {
            this.subjectService.getAll().subscribe(response => {
                console.log('response>>>>>>', response);
                for (const r of response) {
                    this.add(r);
                }
            }, error => {

            });
        }, 100);
    }

    public add(store: Subject) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: Subject) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: Subject) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subjects/subjectDatabase.ts